import { PermissionGroup, Permission, PermissionGroupId, PermissionGroups } from "../DTOs";

export const permissionHelper = {
    hasPermission,
    canEditTargetUser,
    canEditTargetGroupId,
    canEditTargetGroup,
    canAdminEditTargetGroupId,
    canAdminEditTargetGroup,
    canAdminEditTargetUser,
}


function hasPermission(group:PermissionGroup, required:Permission) {
    return group.permissions.find(p => p===required) !== undefined;
}


// Two types of user editing:

// 1
// Profile data: name, email, password, roles
// Self and admins
function canEditTargetGroup(activeUserPg:PermissionGroup, targetUserPg:PermissionGroup, isSelf:boolean):boolean
{
    // Can always edit self
    if(isSelf)
        return true;

    // SuperAdmins can do anything
    if(hasPermission(activeUserPg, 'SuperAdmin')){
        if(hasPermission(targetUserPg, 'SuperAdmin')){
            return false;
        }
        return true;
    }

    // Siteadmins can edit all non-site- and superadmins
    if(hasPermission(activeUserPg, 'UserAdmin')){
        if(hasPermission(targetUserPg, 'UserAdmin')){
            return false;
        }
        return true;
    }

    // Not an admin and not self
    return false;
}

function canEditTargetGroupId(activeUserPgId:PermissionGroupId, targetUserPgId:PermissionGroupId, isSelf:boolean):boolean
{
    const activeUser = PermissionGroups.all.find(pg => pg.id === activeUserPgId);
    if(!activeUser)
        throw new Error('invalid activeUserPgId');
    const targetUser = PermissionGroups.all.find(pg => pg.id === targetUserPgId);
    if(!targetUser)
        throw new Error('invalid targetUserPgId');

    return canEditTargetGroup(
        activeUser,
        targetUser,
        isSelf
    );
}

function canEditTargetUser(
    activeUser:{ id:string, permissionGroup:PermissionGroup, enabled:boolean}, 
    targetUser:{ id:string, permissionGroup:PermissionGroup}
):boolean
{
    // Permission to actual function must have already been established
    if(!activeUser.enabled)
        return false;

    return canEditTargetGroup(
        activeUser.permissionGroup, 
        targetUser.permissionGroup, 
        activeUser.id === targetUser.id
    );
}

// 2
// Admin actions such as permissiongroup, disable/enable, unconfirmed email and unknown existing password
// Admins only
function canAdminEditTargetGroup(activeUserPg:PermissionGroup, targetUserPg:PermissionGroup, isSelf:boolean):boolean
{
    // Can never edit self
    if(isSelf)
        return false;

    if(hasPermission(activeUserPg, 'SuperAdmin'))
    {
        // If activeUser is superadmin, and targetUser isn't, edit is allowed.
        // Wont be same user
        if(hasPermission(targetUserPg, 'SuperAdmin'))
            return false;
        return true;
    }

    if(hasPermission(activeUserPg, 'UserAdmin'))
    {
        // If activeUser is siteadmin, and targetUser isn't, edit is allowed.
        // Wont be same user and also wont be superuser
        if(hasPermission(targetUserPg, 'UserAdmin')){
            return false;
        }
        return true;
    }

    return false;
}

function canAdminEditTargetGroupId(activeUserPgId:PermissionGroupId, targetUserPgId:PermissionGroupId, isSelf:boolean):boolean
{
    const activeUser = PermissionGroups.all.find(pg => pg.id === activeUserPgId);
    if(!activeUser)
        throw new Error('invalid activeUserPgId');
    const targetUser = PermissionGroups.all.find(pg => pg.id === targetUserPgId);
    if(!targetUser)
        throw new Error('invalid targetUserPgId');

    return canAdminEditTargetGroup(
        activeUser,
        targetUser,
        isSelf
    );
}

function canAdminEditTargetUser(
    activeUser:{ id:string, permissionGroup:PermissionGroup, enabled:boolean}, 
    targetUser:{ id:string, permissionGroup:PermissionGroup}    
):boolean
{
    // Permission to actual function must have already been established
    if(!activeUser.enabled)
        return false;

    return canAdminEditTargetGroup(
        activeUser.permissionGroup,
        targetUser.permissionGroup,
        activeUser.id === targetUser.id
    );
}